/**
 * EventCard.js — Valle della Pace event card.
 *
 * OVERRIDES: src/components/base/EventCard.js
 *
 * MIGRATION PARITY (old createEvents, valledellapace/script.js 2962-2994):
 *   A WHITE card with the cover image on TOP, then a header block
 *   (title / date / time / location / sub_title) and a footer with a pill
 *   "Learn more" button + a price block + the CTA link. (NOT the goose
 *   blurred-overlay layout — that was a wrong fork.)
 *
 * EVENTS OUT: ws-prompt-select (cover / Learn more → detail view).
 *
 * Reference: valledellapace/script.js Lines 2962-2994 (createEvents).
 */

import { emit ,isChatDisabled } from "../../../core/state.js";

const CAL_ICON =
  '<svg viewBox="0 0 13 15" width="13" height="14" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.83 0.5v2.67M9.17 0.5v2.67M0.5 5.83h12M1.83 1.83h9.34A1.33 1.33 0 0 1 12.5 3.17v9.33a1.33 1.33 0 0 1-1.33 1.33H1.83A1.33 1.33 0 0 1 0.5 12.5V3.17a1.33 1.33 0 0 1 1.33-1.34z"/></svg>';

export default class EventCard {
  render(ev) {
    const card = document.createElement("div");
    card.className = "ws-card ws-event-card ws-vp-event";

    const openDetail = () => {
      if(isChatDisabled()) return;
      const label = ev.message || `Tell me more about ${ev.title || "this event"}`;
      // uniqueId → BE returns this event's detail card (detailed_event_information).
      emit("ws-prompt-select", { label, value: label, uniqueId: ev.unique_id });
    };

    // Cover image on top — clickable → detail (old .event-cover-image).
    if (ev.cover_image_link) {
      const cover = document.createElement("div");
      cover.className = "ws-vp-event-cover";
      cover.style.cursor = "pointer";
      cover.addEventListener("click", openDetail);
      const img = document.createElement("img");
      img.src = ev.cover_image_link;
      img.alt = ev.title || "Event";
      img.loading = "lazy";
      cover.appendChild(img);
      card.appendChild(cover);
    }

    const inner = document.createElement("div");
    inner.className = "ws-vp-event-inner";

    // Header: title / date / time / location / sub_title.
    const header = document.createElement("div");
    header.className = "ws-vp-event-header";
    const line = (cls, text, titleAttr) => {
      if (!text) return;
      const p = document.createElement("p");
      p.className = cls;
      if (titleAttr) p.title = text;
      p.textContent = text;
      header.appendChild(p);
    };
    line("ws-vp-event-title", ev.title, true);
    line("ws-vp-event-date", ev.date);
    line("ws-vp-event-time", ev.time);
    line("ws-vp-event-location", ev.location);
    // Old listing shows ONLY sub_title here (script.js 2976 — .event_description =
    // ${wine.sub_title}); the full description belongs to the event-DETAILS card.
    // Don't fall back to the description array, or we show text the old doesn't.
    line("ws-vp-event-desc", ev.sub_title);
    inner.appendChild(header);

    // Footer: Learn more pill, then price block + CTA on one row.
    const footer = document.createElement("div");
    footer.className = "ws-vp-event-footer";

    const learn = document.createElement("button");
    learn.type = "button";
    learn.className = "ws-vp-event-learn";
    learn.innerHTML = `${CAL_ICON}<span>Learn more</span>`;
    learn.addEventListener("click", openDetail);
    footer.appendChild(learn);

    const priceRow = document.createElement("div");
    priceRow.className = "ws-vp-event-pricerow";

    const priceBlock = document.createElement("div");
    priceBlock.className = "ws-vp-event-price";
    if (ev.price) {
      const p = document.createElement("p");
      p.textContent = ev.price;
      priceBlock.appendChild(p);
    }
    if (ev.price_unit) {
      const u = document.createElement("p");
      u.textContent = ev.price_unit;
      priceBlock.appendChild(u);
    }
    priceRow.appendChild(priceBlock);

    if (ev.cta_link) {
      const cta = document.createElement("a");
      cta.className = "ws-vp-event-cta";
      cta.href = ev.cta_link;
      cta.target = "_blank";
      cta.rel = "noopener noreferrer";
      cta.textContent = ev.cta_text || "Get tickets";
      priceRow.appendChild(cta);
    }
    footer.appendChild(priceRow);

    inner.appendChild(footer);
    card.appendChild(inner);
    return card;
  }
}
